export default {
    isCompanyPlatform:
        process.env.VUE_APP_ORGANIZATION_TYPE && process.env.VUE_APP_ORGANIZATION_TYPE === '2',
    isSchoolPlatform:
        !process.env.VUE_APP_ORGANIZATION_TYPE || process.env.VUE_APP_ORGANIZATION_TYPE === '1',
};
